import { getMosaicAspectRatio, getMosaicScale } from "@ext/markdown/elements/gallery/logic/getMosaicStyles";
import type { GalleryView } from "@ext/markdown/elements/gallery/model/gallery";
import CarouselView from "@ext/markdown/elements/gallery/render/views/CarouselView";
import MosaicView from "@ext/markdown/elements/gallery/render/views/MosaicView";
import type { GalleryViewProps } from "@ext/markdown/elements/gallery/render/views/types";
import type { ComponentType } from "react";

interface GalleryViewDefinition {
	Component: ComponentType<GalleryViewProps>;
	getDefaultScale: (ratios: number[]) => string;
	getAspectRatio?: (ratios: number[]) => number | undefined;
}

const galleryViews: Record<GalleryView, GalleryViewDefinition> = {
	mosaic: { Component: MosaicView, getDefaultScale: getMosaicScale, getAspectRatio: getMosaicAspectRatio },
	carousel: { Component: CarouselView, getDefaultScale: () => "200%" },
};

export default galleryViews;
